export enum Limit {
    TABLE = 'table',
    ALL = 'all',
    CUSTOM = 'custom',
}
